export default __webpack_public_path__ + "static/media/mobile.3f660f1e.svg";